module.exports = __webpack_public_path__ + "img/04_Trennseite_Lineares@2x.3507b65e.jpg";